import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { isServer } from 'lib/renderHelpers';
import { getQhUserId } from 'store/user/userSelectors';
import Visibility from 'lib/browser/visibility';
import { useEvent, useMount, useUnmount } from 'react-use';

const POLLING_INTERVAL = 1000; // 1 second

const TimeOnPageReporter = React.memo(({ eventName }) => {
  const qhUserId = useSelector(getQhUserId);
  const startTime = new Date();
  let poller;
  let elapsedTime = 0;

  const incrementTime = () => {
    elapsedTime += 1;
  };

  const sendBeaconEvent = useCallback(() => {
    Visibility.stop(poller);

    if (navigator && navigator.sendBeacon) {
      const url = '/hotels/split/events';
      const event = {
        id: qhUserId || 'unknown',
        event: eventName,
        value: elapsedTime,
        properties: {
          startTime,
        },
      };

      const payload = JSON.stringify(event);

      navigator.sendBeacon(url, payload);
    }
  }, [elapsedTime, eventName, poller, qhUserId, startTime]);

  useMount(() => {
    if (isServer()) return null;

    poller = Visibility.every(POLLING_INTERVAL, incrementTime);
  });

  useUnmount(sendBeaconEvent);
  useEvent('unload', sendBeaconEvent);

  return null;
});

TimeOnPageReporter.displayName = 'TimeOnPageReporter';

TimeOnPageReporter.propTypes = {
  eventName: PropTypes.string.isRequired,
};

export default TimeOnPageReporter;
